export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10213.371ce700.jpg";